import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "@remix-run/react";
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { usePath } from '../../../config/VideoAppContext';
import { useDataDispatch } from '../../../providers/DataProvider/DataContext';
import { TransparentButton } from '../../ClickableComponents/Button';
import { DialogActionSection } from '../DialogActionSection';
import { DialogContentWrapper } from '../DialogContentWrapper';
import { useDialogDispatch } from '../DialogContext';
import { DialogTextSection } from '../DialogTextSection';

// TODO PersonalizationDialogText ist spezifiziert auf favorisieren
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PersonalizationDialog = () => {
  const {
    t
  } = useTranslation();
  const dispatchPopup = useDialogDispatch();
  const dispatchData = useDataDispatch();
  const {
    settingsPath
  } = usePath();
  return /*#__PURE__*/_jsx(DialogContentWrapper, {
    title: t('personalization.enablePersonalization'),
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(DialogTextSection, {
        title: t('personalization.enablePersonalization'),
        children: /*#__PURE__*/_jsxs(TextWrapper, {
          children: [/*#__PURE__*/_jsx(Text, {
            children: t('personalization.dialogText')
          }), "\xA0", /*#__PURE__*/_jsx(LearnMore, {
            to: settingsPath,
            onClick: () => dispatchPopup({
              type: 'remove-dialog'
            }),
            children: t('global.learnMore')
          })]
        })
      }), /*#__PURE__*/_jsxs(DialogActionSection, {
        children: [/*#__PURE__*/_jsx(TransparentButton, {
          type: "text",
          text: t('global.cancel'),
          onClick: () => dispatchPopup({
            type: 'remove-dialog'
          })
        }), /*#__PURE__*/_jsx(TransparentButton, {
          type: "text",
          text: t('global.enable'),
          onClick: () => {
            dispatchData({
              type: 'set-personalization',
              enable: true,
              showNotification: true
            });
            dispatchPopup({
              type: 'remove-dialog'
            });
          }
        })]
      })]
    })
  });
};
const TextWrapper = styled.div.withConfig({
  displayName: "PersonalizationDialog__TextWrapper",
  componentId: "sc-1bo8lb2-0"
})(["margin-top:24px;"]);
const Text = styled.span.withConfig({
  displayName: "PersonalizationDialog__Text",
  componentId: "sc-1bo8lb2-1"
})(["white-space:pre-wrap;color:", ";", ";line-height:24px;"], Colors.GREY_d2d2d2, Fonts.regular(16));
const LearnMore = styled(Link).withConfig({
  displayName: "PersonalizationDialog__LearnMore",
  componentId: "sc-1bo8lb2-2"
})(["color:", ";", ";line-height:24px;align-self:start;"], Colors.WHITE, Fonts.regular(16));
const Container = styled.div.withConfig({
  displayName: "PersonalizationDialog__Container",
  componentId: "sc-1bo8lb2-3"
})(["display:flex;flex-direction:column;max-width:382px;"]);